import { StyledSelectWrapper } from 'components/styledComponents/select/Select.styled';
import type { DefaultOptionType } from 'antd/es/select';
import { AdminSingleProps, SelectOptionProps } from './AdminSelect';

const AdminSingleSelect = <
  OptionType extends SelectOptionProps,
  IsToString extends boolean = true
>({
    data, renderOptions, ...rest
  }:AdminSingleProps<OptionType, IsToString>) => (
    <StyledSelectWrapper
      showSearch={{
        filterOption: (input, option?: DefaultOptionType) => {
          if (!option) return false;

          const label = (option?.children ?? '').toString().toLowerCase();

          return label.startsWith(input.toLowerCase());
        },
      }}
      {...rest}
    >
      {data && renderOptions?.(data)}
    </StyledSelectWrapper>
  );

export default AdminSingleSelect;
